import { useTenant } from '@emerald-works-nova/auth'
import { useSession } from '@emerald-works/react-auth'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import consts from '../consts'
import { subscriptionSlice, userSlice } from '../reducers'
import useGroup from './useGroup'
import usePaidConsumer from './usePaidConsumer'

const STUDENT_PLAN_CODE = 'mt-student-plan-monthly'

const isStudentPlanCode = (planCode) => planCode === STUDENT_PLAN_CODE

const useIsStudentPlan = () => {
  const tenant = useTenant()
  const { isAuthenticated } = useSession()
  const { groups } = useGroup()
  const { isPaidConsumer } = usePaidConsumer()
  const accountInfo = useSelector(subscriptionSlice.selectors.selectAccountInfo)
  // "Answered", not "loaded": a fetch that failed with nothing behind it is
  // still an answer here. `null` hides M:Coach and the Mindset agent until the
  // plan is known, and an account whose fetch always fails — an admin with no
  // billing account — would otherwise never get them.
  const accountInfoSettled = useSelector(subscriptionSlice.selectors.selectAccountInfoSettled)
  const profile = useSelector(userSlice.selectors.selectProfile)
  const isProfileLoaded = useSelector(userSlice.selectors.selectIsProfileLoaded)

  const planCode = accountInfo.plan?.id || profile?.subscription?.code
  const isClub = tenant.pk === consts.DEFAULT_CLUB_PK

  const isStudentPlan = useMemo(() => {
    if (!isClub) return false

    if (!isAuthenticated) return false

    if (!isProfileLoaded || groups === undefined) return null

    if (!isPaidConsumer) return false

    if (typeof planCode === 'string') {
      return isStudentPlanCode(planCode)
    }

    if (!accountInfoSettled) return null

    return false
  }, [isClub, isAuthenticated, isProfileLoaded, groups, isPaidConsumer, planCode, accountInfoSettled])

  return { isStudentPlan }
}

export { STUDENT_PLAN_CODE, isStudentPlanCode }
export default useIsStudentPlan
